/* eslint-disable arrow-body-style */
import { mergeMap, Observable, timer } from 'rxjs';
import { AjaxResponse } from 'rxjs/ajax';
import { env } from 'libs/constants/env';
import ApiProvider from 'libs/providers/api/api.provider';
import { getDocumentFormat, getIdDocumentType } from '../utils';
import CreateCustomerParamsModel from '../models/createCustomerParams';
import { CreateCustomerParams } from '../interfaces/customer';
import {
  CreateOpportunityParams,
  EnqueueOpportunity,
  PatchOpportunityParams,
} from '../interfaces/opportunity';
import RequestProvider from 'domains/core-base/request/providers/request-provider';
import { GetCustomerDto, GetOpportunityDto, AdvisorIdentifierDto } from '../dto/customer-dto';
import CreateOpportunityParamsModel from '../models/createOpportunity';
import PatchOpportunityParamsModel from '../models/patchOpportunity';

class OracleProvider {
  static _provider: ApiProvider = new ApiProvider();

  static getCustomer = ({
    authorization,
    documentId,
    documentType,
  }: {
    documentId: string;
    documentType: string;
    authorization: string;
  }): Observable<AjaxResponse<GetCustomerDto>> => {
    return this._provider.post(
      `${env.CONTEXT_PATH}/crm/contactos/buscar`,
      {
        tipoDocumento: getIdDocumentType(documentType),
        numeroDocumento: getDocumentFormat(
          documentId,
          documentType,
        )
      },
      {
        Authorization: authorization,
        'Transaccion-Id': env.DEFAULT_REQUEST_ID,
      },
    );
  };

  static createCustomer = (params: {
    authorization: string;
    customer: CreateCustomerParams;
  }): Observable<AjaxResponse<GetCustomerDto>> => {
    const { authorization, customer } = params;
    const data = new CreateCustomerParamsModel(customer);
    const request = RequestProvider.getInstance();
    return this._provider.post(
      `${env.CONTEXT_PATH}/crm/contactos`,
      {
        ...data,
      },
      {
        Authorization: authorization,
        'Transaccion-Id': request.getRequestId(),
      },
    );
  };

  static createOpportunnity = (params: {
    authorization: string;
    data: CreateOpportunityParams;
    recaptcha: string;
  }): Observable<AjaxResponse<GetOpportunityDto>> => {
    const { authorization, data } = params;
    const opportunity = new CreateOpportunityParamsModel(data);
    const request = RequestProvider.getInstance();
    return this._provider.post(
      `${env.CONTEXT_PATH}/crm/oportunidades`,
      {
        ...opportunity,
      },
      {
        Authorization: authorization,
        'Transaccion-Id': request.getRequestId(),
        'g-recaptcha-response': params.recaptcha,
      },
    );
  };

  static readonly patchPhase = (params: {
    authorization: string;
    optyNumber: string;
    data: PatchOpportunityParams;
    recaptcha: string;
  }): Observable<AjaxResponse<any>> => {
    const { authorization, data, optyNumber } = params;
    const opportunity = new PatchOpportunityParamsModel(data);
    const request = RequestProvider.getInstance();
    return timer(5000).pipe(
      mergeMap(() =>
        this._provider.patch(
          `${env.CONTEXT_PATH}/crm/oportunidades/${optyNumber}`,
          {
            ...opportunity,
          },
          {
            Authorization: authorization,
            'Transaccion-Id': request.getRequestId(),
            'g-recaptcha-response': params.recaptcha,
          },
        ),
      ),
    );
  };

  static readonly createEnqueueOportunity=(params: {
    data: EnqueueOpportunity,
    authorization: string,
    recaptcha: string,
  }): Observable<AjaxResponse<AdvisorIdentifierDto>>=> {
    const { authorization, data } = params;
    const request = RequestProvider.getInstance();
    return this._provider.post(
      `${env.CONTEXT_PATH}/crm/colaOportunidades`,
      {
        ...data,
      },
      {
        Authorization: authorization,
        'Transaccion-Id': request.getRequestId(),
        'g-recaptcha-response': params.recaptcha,
      },
    );
  }

  static readonly updateEnqueueOportunity = (params: {
    advisorIdentifier: string;
    authorization: string;
    recaptcha: string;
    data: PatchOpportunityParams;
  }): Observable<AjaxResponse<AdvisorIdentifierDto>> => {
    const request = RequestProvider.getInstance();
    const opportunity = new PatchOpportunityParamsModel(params.data);
    return this._provider.patch(
      `${env.CONTEXT_PATH}/crm/colaOportunidades/${params.advisorIdentifier}`,
      {
       ...opportunity,
      },
      {
        Authorization: params.authorization,
        'Transaccion-Id': request.getRequestId(),
        'g-recaptcha-response': params.recaptcha,
      },
    );
  }

}

export default OracleProvider;
